import app from "../_app";
import {get} from "./_cookie";

[...document.querySelectorAll('.js-newsletter-subscribe')].map(newsletterForm => {

    const subscribe = () => {
        let emailAddress = newsletterForm.querySelector('input[name="email"]').value;

        var settings = {
            "g":        "YyjiGp",
            "email":    `${emailAddress}`
        }

        fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
            method:  'POST',
            headers: {
                'Content-Type':  'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache'
            },
            body:    new URLSearchParams(settings)
        })
            .then(function (response) {
                if (response.status === 200) {
                    const newsletterSignupMessage = newsletterForm.querySelector('.js-newsletter-signup-message');
                    newsletterSignupMessage.innerHTML = app.translationHelper('footer.newsletter.success');
                }
            });
    };


    newsletterForm.addEventListener('submit', e => {
        e.preventDefault();

        let hasTargetingConsent = false;
        let emailAddress = newsletterForm.querySelector('input[name="email"]').value;

        try {
            const consentCookie = get('_pandectes_gdpr');
            const decodedCookie = atob(consentCookie);
            const jsonConsent = JSON.parse(decodedCookie);

            if(+jsonConsent.preferences <= 3) {
                hasTargetingConsent = true
            }
        } catch(e) {}

        if(hasTargetingConsent) {
            klaviyo.identify({
                '$email' :  `${emailAddress}`
            });
        }

        subscribe();
    });
});
